
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-getting-started-demo-helloworld","docs-tutorial-getting-started-demo-react-shape","docs-tutorial-getting-started-demo-use-plugin"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.en.md?type=demo')
};